import React from 'react';
import classname from 'classnames';
import './HelpLink.pcss';

type Props = {
  href: string;
  className?: string;
};
export const HelpLink = (props: Props) => {
  const { href, className } = props;
  return (
    <a
      className={classname('help-link', className)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="far fa-question-circle" />
    </a>
  );
};
